import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";

import type { LocationsAccessorialQuestionBubbleProps } from "../Types/LocationsAccessorialQuestionBubbleTypes";
import { describeLocationContext } from "@/Helpers/describeLocationContext";
import { describeInsideAccessorial } from "../Helpers/describeInsideAccessorial";

interface LocationsInsideQuestionBubbleProps extends LocationsAccessorialQuestionBubbleProps {
  /**
   * The checkbox is greyed out because the location is residential. The bubble
   * stays — it's the only place the customer can find out why the option they
   * were looking for is disabled.
   */
  unavailableForResidential?: boolean | undefined;
}

const LocationsInsideQuestionBubble = (
  props: LocationsInsideQuestionBubbleProps,
) => {
  return (
    <Tooltip
      interactive
      variant="info"
      content={
        <Stack gap={2}>
          <T weight="bold">
            {`Inside ${describeLocationContext(props.locationContext)}`}
          </T>
          <T size="xs" color="secondary">
            {describeInsideAccessorial(
              props.locationContext,
              props.unavailableForResidential ?? false,
            )}
          </T>
          <Link
            href="https://help.freightsimple.com/freight-101/special-services/inside-pickup-delivery"
            external
          >
            Learn more
          </Link>
        </Stack>
      }
    />
  );
};
export default LocationsInsideQuestionBubble;
